import ViewProjektForm from '../../components/views/rejestr/lib/components/projektForm/kp1/ViewProjektForm.jsx'
import ViewListaElementyRejestru from '../../components/views/rejestr/oper/listaPozycjiRejestru/ViewListaElementyRejestru.jsx'
import ViewListaProfiliProjektu from '../../components/views/rejestr/wp/listaProfiliProjektu/ViewListaProfiliProjektu.jsx'

import { MAIN_REJESTR_API_LONG } from '../../components/utils/consts.js'
import ViewListaProcesuHarmonogramu
    from "../../components/views/rejestr/wp/listaProcesuHarmonogramu/ViewListaProcesuHarmonogramu.jsx";
import ViewListaProcesuProjektu
    from "../../components/views/rejestr/wp/listaProcesuProjektu/ViewListaProcesuProjektu.jsx";
import ViewListaProcesuSprawozdania
    from "../../components/views/rejestr/wp/listaProcesuSprawozdania/ViewListaProcesuSprawozdania.jsx";
import ViewPlanHarmForm from "../../components/views/planHarm/oper/planHarmForm/ph1/ViewPlanHarmForm.jsx";
import {
    ViewPlanHarmGantt
} from "../../components/views/planHarm/lib/components/planHarmGantt/pages/ViewPlanHarmGantt.jsx";

export const rejestrRoutes = [
    {
        path: `/oper/${MAIN_REJESTR_API_LONG}/karta/podglad/:id`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewProjektForm />,
        mode: `any`,
    },
    {
        path: `/oper/${MAIN_REJESTR_API_LONG}/karta/edycja/:id`,
        exact: true,
        roles: [`rejestr_modyfikacja`],
        forbidden: true,
        view: <ViewProjektForm />,
        mode: `any`,
    },
    {
        path: `/oper/${MAIN_REJESTR_API_LONG}/lista`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewListaElementyRejestru />,
        mode: `any`,
    },
    {
        path: `/oper/${MAIN_REJESTR_API_LONG}/:id/profile`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewListaProfiliProjektu />,
        mode: `any`,
    },
    {
        path: `/oper/harm/podglad/:rejestrId`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewPlanHarmForm />,
        mode: `any`,
    },
    {
        path: `/oper/harm/podglad/:rejestrId/:planHarmId`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewPlanHarmForm />,
        mode: `any`,
    },
    {
        path: `/oper/harm/edycja/:rejestrId`,
        exact: true,
        roles: [`rejestr_modyfikacja`],
        forbidden: true,
        view: <ViewPlanHarmForm />,
        mode: `any`,
    },
    {
        path: `/oper/harm/edycja/:rejestrId/:planHarmId`,
        exact: true,
        roles: [`rejestr_modyfikacja`],
        forbidden: true,
        view: <ViewPlanHarmForm />,
        mode: `any`,
    },
    {
        path: `/oper/harm/proces/lista/:rejestrId`,
        exact: true,
        roles: [`rejestr_obsluga_podglad`],
        forbidden: true,
        view: <ViewListaProcesuHarmonogramu />,
        mode: `any`,
    },
    {
        path: `/oper/harm/gantt/:rejestrId`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewPlanHarmGantt />,
        mode: `any`,
    },
    {
        path: `/oper/harm/gantt/:rejestrId/:planHarmId`,
        exact: true,
        roles: [`rejestr_podglad`],
        forbidden: true,
        view: <ViewPlanHarmGantt />,
        mode: `any`,
    },
    {
        path: `/oper/${MAIN_REJESTR_API_LONG}/proces/lista/:rejestrId`,
        exact: true,
        roles: [`rejestr_obsluga_podglad`],
        forbidden: true,
        view: <ViewListaProcesuProjektu />,
        mode: `any`,
    },
    {
        path: `/oper/sprawozdanie/proces/lista/:rejestrId`,
        exact: true,
        roles: [`rejestr_obsluga_podglad`],
        forbidden: true,
        view: <ViewListaProcesuSprawozdania />,
        mode: `any`,
    },
]
